import { render, staticRenderFns } from "./SaaSHerramientas.vue?vue&type=template&id=11e201a9&scoped=true"
import script from "./SaaSHerramientas.vue?vue&type=script&lang=js"
export * from "./SaaSHerramientas.vue?vue&type=script&lang=js"
import style0 from "./SaaSHerramientas.vue?vue&type=style&index=0&id=11e201a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e201a9",
  null
  
)

export default component.exports